import React from "react";

export default function index() {
  return (
    <section>
      <h1>Education</h1>

      <h2>Ironhack Mexico</h2>

      <h3>Web Development, Computer Programming</h3>

      <h4>October 2021 - December 2021</h4>

      <p>9 week intensive web development bootcamp.</p>
      <p>Built front end projects and full stack projects.</p>

      <hr className="border-b-2 border-rose-100"/>

      <h2>Universidad Nacional Autónoma de México</h2>

      <h3>Master in Administration</h3>

      <h4>2014 - 2016</h4>

      <p>
        Master for the direction, development, consulting, promotion and
        strengthening of organizations belonging to Health Systems, within a
        framework of ethics and social responsibility, with the ability to
        formulare and implement strategies, participate in decision making and
        resolution of problems faced by these organizations.
      </p>

      <hr className="border-b-2 border-rose-100"/>

      <h2>Universidad Autónoma de Yucatán</h2>

      <h3> Emergency Medicine</h3>

      <h4>2011 - 2014</h4>

      <p>
      Three-year residency in a second-level hospital providing medical attention to
         patients in the emergency area, under the tutelage of a group of
         specialists.
      </p>
    </section>
  );
}
